import { createRoot } from 'react-dom/client'
import App from './App'
import { redirectToMobileApp } from './redirectMobile'

// Send mobile-device visitors to the mobile web app before anything renders.
redirectToMobileApp()

const router = createBrowserRouter([{ path: '*', Component: App }])

import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import reportWebVitals from './reportWebVitals'

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<RouterProvider router={router} />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
